import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
let pending = null;

// Shared, cached /content fetch so layout pieces don't refetch the CMS on every page.
export const loadSiteContent = () => {
  if (!pending) {
    pending = api
      .get("/content")
      .then((r) => (cache = r.data))
      .catch(() => {
        pending = null;
        return null;
      });
  }
  return pending;
};

export const useSiteContent = () => {
  const [content, setContent] = useState(cache);
  useEffect(() => {
    let alive = true;
    if (!cache) loadSiteContent().then((c) => alive && setContent(c));
    return () => {
      alive = false;
    };
  }, []);
  return content;
};

export const sectionImage = (content, href) =>
  content?.homepage_sections?.items?.find((i) => i.href === href)?.image || "";
